import React from 'react';

const TransparentLoader = ({ fixed = false }) => (
  <div className={`transparent-loader ${fixed && 'position-fixed'}`}>
    <div className="inner">Adding to Cart...</div>
  </div>
);

export default TransparentLoader;
